import React, { useState } from "react";
import axios from "axios";
import Results from "./Results.js";
import "./App.css";

export default function Dictionary() {
  const [word, setWord] = useState("Happiness");
  const [loaded, setLoaded] = useState(false);
  const [result, setResult] = useState({});

  function search(event) {
    event.preventDefault();
    alert(`Searching for ${word}`);
    setLoaded(false);
  }

  function changeWord(event) {
    setWord(event.target.value);
  }

  function handleResponse(response) {
    console.log(response.data.meanings[0].definition);
    setLoaded(true);
    setResult(response.data);
  }

  if (loaded) {
    return (
      <div className="dictionary">
        <div className="title section">
          <h1>Welcome</h1>
          <h2>Let's have a word</h2>

          <form onSubmit={search}>
            <input type="search" autoFocus={true} onChange={changeWord} />
          </form>
        </div>
        <Results results={result} />
      </div>
    );
  } else {
    let APIkey = "5fobe02b0dff93d79ecc47a523d0f3t0";
    let APIurl = `https://api.shecodes.io/dictionary/v1/define?word=${word}&key=${APIkey}`;
    axios.get(APIurl).then(handleResponse);
    return <div>LOADING...</div>;
  }
}
